import React, { useState } from 'react';
import { Flex, Text, Button, Heading, Box, Card } from 'rebass';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { Mutation, Query, compose } from 'react-apollo';

import withSession from '../lib/withSession';
import gql from 'graphql-tag';
import PillsBottle from '../static/PillsBottle.png';
import { Skeleton } from '../components/loadingSkeleton/Skeleton';
import medicationManagement from '../static/medicationManagement.png';
import doctorIcon from '../static/doctorIcon.png';

export const GET_VISITS_TOKEN = gql`
  mutation getAsyncVisitToken {
    getAsyncVisitToken
  }
`;

export const GET_PALOMARX_PRODUCTS = gql`
  query getPalomaRxCatalog {
    getPalomaRxCatalog {
      products {
        id
        palomaSku
        name
        category
        imageUrl
        shortDescription
        fromPriceCents
        fulfillment
        available
        eligibleSexes
        visitFeeCents
      }
      updatedAt
    }
  }
`;

const DividerWeb = styled.div`
  width: 1px;
  height: 100%;
  background-color: #344f79;
  @media screen and (max-width: 640px) {
    display: none;
  }
`;

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  padding-top: 40px;
  @media screen and (max-width: 52em) {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

const InnerContainer = styled(Flex)`
  max-width: 800px;
  margin: 0 auto;
  flex-direction: column;
  margin-bottom: 60px;
  @media screen and (max-width: 1100px) {
    max-width: calc(100vw - 300px);
  }
  @media screen and (max-width: 830px) {
    max-width: calc(100vw - 80px);
  }
  @media screen and (max-width: 52em) {
    max-width: 96%;
  }
`;

const Img = styled.img`
  display: initial;
  width: 200px;
  @media screen and (max-width: 52em) {
    width: 100%;
  }
`;
const FlexCard = styled(Flex)`
  flex-direction: row;
  @media screen and (max-width: 52em) {
    flex-direction: column;
  }
`;

const CategorySelector = ({ selected, setSelected, allCategories }) => {
  if (!allCategories || allCategories.length < 2) return null;
  return (
    <Flex style={{ flexWrap: 'wrap', gap: 5 }}>
      <Button
        onClick={() => setSelected(null)}
        p={'3px 12px !important'}
        variant={!selected ? 'primary' : 'outline'}
        style={{
          border: '1px solid #344F79',
          maxHeight: 'fit-content',
          padding: '3px 12px !important',
          paddingLeft: '12px !important',
          paddingRight: '12px !important',
          paddingTop: '3px !important',
          paddingBottom: '3px !important',
          fontWeight: 400,
          width: 'fit-content',
        }}
      >
        All Products
      </Button>
      {allCategories.map((category) => (
        <Button
          key={category}
          onClick={() => setSelected(category)}
          p={'3px 12px !important'}
          style={{
            border: '1px solid #344F79',
            maxHeight: 'fit-content',
            width: 'fit-content',
            padding: '3px 12px !important',
            paddingLeft: '12px !important',
            paddingRight: '12px !important',
            paddingTop: '3px !important',
            paddingBottom: '3px !important',
            fontWeight: 400,
          }}
          variant={selected === category ? 'primary' : 'outline'}
        >
          {category || 'Uncategorized'}
        </Button>
      ))}
    </Flex>
  );
};

const CategorySelectorSkeleton = () => {
  return (
    <Flex style={{ flexWrap: 'wrap', gap: 5 }}>
      <Skeleton height="26px" width="111px" borderRadius="13px" baseColor="#344f79" highlightColor="#666e79" style={{ opacity: 0.5 }} />
      <Skeleton height="26px" width="93px" borderRadius="13px" />
      <Skeleton height="26px" width="131px" borderRadius="13px" />
    </Flex>
  );
};

export const PalomaRxProductCardSkeleton = () => {
  return (
    <Card style={{ borderRadius: 10, padding: 0, overflow: 'hidden', opacity: 0.5 }}>
      <Flex>
        <Img src={PillsBottle} alt="" style={{ objectFit: 'contain', opacity: 0.35 }} width="200px" />
        <Flex flex={1} flexDirection={'column'} style={{ padding: '16px 32px', gap: 12 }}>
          <Flex style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Card p={'3px 12px'} style={{ background: '#EBE6A7', maxWidth: 'fit-content', borderRadius: 20 }}>
              <Skeleton height={'14px'} width={'85px'} />
            </Card>
            <Skeleton height={'14px'} width={'105px'} />
          </Flex>
          <Flex style={{ gap: 8, flexDirection: 'column' }}>
            <Skeleton height={'26px'} width={'145px'} />
            <Flex flexDirection={'column'}>
              <Skeleton height={'14px'} width={'100%'} />
              <Skeleton height={'14px'} width={'65%'} />
            </Flex>
          </Flex>
          <Flex style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <Skeleton height={'32px'} width={'155px'} borderRadius="16px" baseColor="#344f79" highlightColor="#666e79" style={{ opacity: 0.5 }} />
            <Skeleton height={'24px'} width={'86px'} />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
export const PALOMA_PRODUCT_TAG_COLORS = [
  {
    bg: '#EBE6A7',
    text: '#2F4772',
  },
  {
    bg: '#D8E7F7',
    text: '#2F4772',
  },
  {
    bg: '#F4D6CB',
    text: '#7A3D2C',
  },
  {
    bg: '#EADCF8',
    text: '#56306F',
  },
  {
    bg: '#D8EEE5',
    text: '#275C4B',
  },
  {
    bg: '#F6DCE8',
    text: '#74324F',
  },
  {
    bg: '#F3E0BD',
    text: '#6A4A19',
  },
  {
    bg: '#DBE1F3',
    text: '#31446F',
  },
  {
    bg: '#F7E7C6',
    text: '#72521C',
  },
  {
    bg: '#DCEBD2',
    text: '#3C5F2B',
  },
];

export const PalomaRxProductCard = ({ product, history, categoryIndex }) => {
  return (
    <Mutation
      mutation={GET_VISITS_TOKEN}
      onCompleted={(e) => {
        if (e && e.getAsyncVisitToken) {
          window.location = `${window._env_.REACT_APP_RX_VISITS_URL}/auth#token=${encodeURIComponent(e.getAsyncVisitToken)}&redirect=${product.palomaSku}`;
        }
      }}
    >
      {(generateToken, { loading }) => (
        <Card style={{ borderRadius: 10, padding: 0, overflow: 'hidden', opacity: !!loading ? 0.5 : 1 }}>
          <FlexCard>
            <Img src={product.imageUrl} alt="" style={{ objectFit: 'cover' }} />
            <Flex flex={1} flexDirection={'column'} style={{ padding: '16px 32px', gap: 12 }}>
              <Flex style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Card
                  p={'3px 12px'}
                  style={{
                    background: PALOMA_PRODUCT_TAG_COLORS[(categoryIndex || 0) > PALOMA_PRODUCT_TAG_COLORS.length - 1 ? 0 : categoryIndex || 0].bg || '#EBE6A7',
                    maxWidth: 'fit-content',
                    borderRadius: 20,
                  }}
                >
                  <Text fontSize={14} fontWeight={300} color={PALOMA_PRODUCT_TAG_COLORS[(categoryIndex || 0) > PALOMA_PRODUCT_TAG_COLORS.length - 1 ? 0 : categoryIndex || 0].text || ''}>
                    {product.category}
                  </Text>
                </Card>
                {/* <Text fontSize={14} fontWeight={300}>
                  from ${(product.fromPriceCents / 100).toFixed(2)}
                </Text> */}
              </Flex>
              <Flex style={{ gap: 8, flexDirection: 'column' }}>
                <Heading fontSize={26}>{product.name}</Heading>
                <Text fontSize={14}>{product.shortDescription}</Text>
              </Flex>
              <Flex width={'100%'} style={{ borderRadius: '12px', gap: 12, background: '#fdf5f2', padding: '12px' }} flexDirection={['column', 'row']} alignItems={['flex-start', 'center']}>
                <Flex style={{ gap: 6, flexShrink: 0 }}>
                  {/* <img src={medicationManagement} height="40px" alt="" /> */}

                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 500 500" style={{ marginLeft: '-5px', marginRight: '5px' }}>
                    <g fill="none" stroke="#F3F5EE" stroke-width="1.5" stroke-linecap="round">
                      <path d="M140 384 H174" />
                      <path d="M186 384 H201" />
                      <path d="M209 385 H260" />
                      <path d="M278 384 H320" />
                      <path d="M337 384 H359" />
                    </g>
                    <g fill="#253D30" opacity=".3">
                      <path d="M140 387 H174" />
                      <path d="M186 387 H201" />
                      <path d="M209 388 H260" />
                      <path d="M278 387 H320" />
                      <path d="M337 387 H359" />
                    </g>

                    <path
                      d="M202 153 H309 V365
           Q309 382 293 382 H218
           Q202 382 202 365 Z"
                      fill="#435982"
                      stroke="#F1F2EC"
                      stroke-width="1.6"
                    />

                    <path d="M204 155 H226 V343 H204 Z" fill="#F0F3ED" />
                    <path d="M226 185 H204 V155 H226 Z" fill="#F0F3ED" />

                    <path d="M308 156 V365 Q308 380 293 380" fill="none" stroke="#8291AB" stroke-width="1.2" />

                    <path d="M193 123 H318 V155 H193 Z" fill="#EB978B" stroke="#F4F3ED" stroke-width="1.5" />
                    <path d="M297 124 H318 V155 H297 Z" fill="#B8786C" opacity=".85" />
                    <path d="M193 123 H318" fill="none" stroke="#FFFFFF" stroke-width="2" />

                    <g transform="translate(241 194) rotate(47)">
                      <rect x="-10" y="-25" width="20" height="50" rx="10" fill="#202C43" stroke="#D9DDD8" stroke-width="1.2" />
                      <path d="M-10 0 V-15 A10 10 0 0 1 10 -15 V0 Z" fill="#B8796A" />
                      <path d="M-10 0 H10" stroke="#D9DDD8" stroke-width="1" />
                    </g>

                    <g transform="translate(255 200) rotate(8)">
                      <rect x="-9" y="-20" width="18" height="40" rx="9" fill="#202C43" stroke="#D9DDD8" stroke-width="1.2" />
                      <path d="M-9 0 V-11 A9 9 0 0 1 9 -11 V0 Z" fill="#B8796A" />
                      <path d="M-9 0 H9" stroke="#D9DDD8" stroke-width="1" />
                    </g>

                    <g transform="translate(241 262) rotate(-36)">
                      <rect x="-9" y="-23" width="18" height="46" rx="9" fill="#202C43" stroke="#D9DDD8" stroke-width="1.2" />
                      <path d="M-9 0 V-14 A9 9 0 0 1 9 -14 V0 Z" fill="#B8796A" />
                      <path d="M-9 0 H9" stroke="#D9DDD8" stroke-width="1" />
                    </g>

                    <g transform="translate(244 282) rotate(74)">
                      <rect x="-9" y="-20" width="18" height="40" rx="9" fill="#202C43" stroke="#D9DDD8" stroke-width="1.2" />
                      <path d="M-9 0 V-11 A9 9 0 0 1 9 -11 V0 Z" fill="#B8796A" />
                      <path d="M-9 0 H9" stroke="#D9DDD8" stroke-width="1" />
                    </g>

                    <g transform="translate(258 343) rotate(42)">
                      <rect x="-9" y="-22" width="18" height="44" rx="9" fill="#202C43" stroke="#D9DDD8" stroke-width="1.2" />
                      <path d="M-9 0 V-13 A9 9 0 0 1 9 -13 V0 Z" fill="#B8796A" />
                      <path d="M-9 0 H9" stroke="#D9DDD8" stroke-width="1" />
                    </g>

                    <g transform="translate(279 354) rotate(-58)">
                      <rect x="-9" y="-23" width="18" height="46" rx="9" fill="#202C43" stroke="#D9DDD8" stroke-width="1.2" />
                      <path d="M-9 0 V-14 A9 9 0 0 1 9 -14 V0 Z" fill="#B8796A" />
                      <path d="M-9 0 H9" stroke="#D9DDD8" stroke-width="1" />
                    </g>

                    <path d="M216 382 H294" fill="none" stroke="#D9E0E0" stroke-width="1.4" stroke-linecap="round" />
                  </svg>
                  {product.fulfillment && product.fulfillment === 'external_pharmacy' ? (
                    <Flex fontWeight={600} flexDirection={'column'}>
                      <Text fontWeight={600} fontSize={'14px'} style={{ whiteSpace: 'nowrap' }}>
                        Paid at your pharmacy
                      </Text>

                      <Text fontSize={13} fontWeight={300} style={{ whiteSpace: 'nowrap' }}>
                        Use your insurance or pay cash
                      </Text>
                    </Flex>
                  ) : (
                    <Flex fontWeight={600} flexDirection={'column'}>
                      <Text fontWeight={600} fontSize={'14px'} style={{ whiteSpace: 'nowrap' }}>
                        From ${(product.fromPriceCents / 100).toFixed(2)}
                        {product.palomaSku && product.palomaSku !== 'LDN' ? ' / mo' : ''}
                      </Text>

                      <Text fontSize={13} fontWeight={300} style={{ whiteSpace: 'nowrap' }}>
                        Billed only if prescribed
                      </Text>
                    </Flex>
                  )}
                </Flex>
                <DividerWeb />
                <Flex style={{ gap: 6 }}>
                  <img src={doctorIcon} height="30px" alt="" style={{ marginTop: '4px', marginRight: '10px' }} />
                  <Flex fontWeight={600} flexDirection={'column'}>
                    <Text fontWeight={600} fontSize={'14px'}>
                      {product.fulfillment && product.fulfillment === 'external_pharmacy' ?'':'+ '}${(product.visitFeeCents / 100).toFixed(0)} clinician review per visit
                    </Text>

                    <Text fontSize={13} fontWeight={300}>
                      Charged when you submit your intake
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
              <Flex style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                  variant={'primary'}
                  onClick={() => {
                    if (!!loading) return;
                    generateToken();
                  }}
                  disabled={!!loading}
                  style={{
                    padding: '8px 42px',
                    width: 'fit-content',
                    maxWidth: 'fit-content',
                    fontSize: 14,
                    fontWeight: 300,
                  }}
                >
                  Get Started
                </Button>

                <Text
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    history.push(`/rx-products/${product.id}`);
                  }}
                >{`More Info >`}</Text>
              </Flex>
            </Flex>
          </FlexCard>
        </Card>
      )}
    </Mutation>
  );
};

const PalomaRxProducts = ({ session, match, history }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  if (!session || !session.eligibility || !session.eligibility.canBookAsync) {
    history.replace('/');
    return null;
  }

  return (
    <>
      <Container>
        <InnerContainer>
          <Flex flexDirection={'column'}>
            <Heading mb={4}>Paloma Custom Rx</Heading>

            <Text mb={3}>Explore prescription treatments that may support your symptoms, health goals, and care plan.</Text>
          </Flex>
          <Query query={GET_PALOMARX_PRODUCTS}>
            {({ loading, data, error }) => {
              if (!!loading) {
                return (
                  <Flex style={{ flexDirection: 'column', gap: 32 }}>
                    <CategorySelectorSkeleton />

                    {[0, 1, 2, 3, 4].map((product) => (
                      <PalomaRxProductCardSkeleton key={product} />
                    ))}
                  </Flex>
                );
              }

              if (error) {
                return (
                  <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
                    <Text fontSize={18} mt={5} style={{ opacity: 0.75 }}>
                      An error occured
                    </Text>
                  </Flex>
                );
              }

              if (!data || !data.getPalomaRxCatalog || !data.getPalomaRxCatalog.products) {
                return (
                  <Flex flex={1} alignItems={'center'} justifyContent={'center'}>
                    <Text fontSize={18} mt={5} style={{ opacity: 0.75 }}>
                      No product available
                    </Text>
                  </Flex>
                );
              }
              const gender = session.gender;

              const products = data.getPalomaRxCatalog.products.filter((x) => {
                if (!x.eligibleSexes || x.eligibleSexes.length < 1) return true;
                if (!gender || gender === 'U') return true;

                if (x.eligibleSexes.findIndex((xx) => xx === gender) < 0) return false;

                return true;
              });

              const allCategories = [...new Set(products.flatMap((item) => item.category))];
              return (
                <Flex style={{ flexDirection: 'column', gap: 32 }}>
                  <CategorySelector selected={selectedCategory} setSelected={setSelectedCategory} allCategories={allCategories} />
                  {products
                    .filter((x) => {
                      if (!selectedCategory) return true;

                      return x.category.indexOf(selectedCategory) > -1;
                    })
                    .map((product) => {
                      const categoryIndex = allCategories.findIndex((x) => x === product.category);

                      return <PalomaRxProductCard key={product.id} product={product} history={history} categoryIndex={categoryIndex} />;
                    })}
                </Flex>
              );
            }}
          </Query>
        </InnerContainer>
      </Container>
    </>
  );
};

export default compose(
  withSession,
  withRouter,
)(PalomaRxProducts);
